import reduce from 'lodash-es/reduce'

import { FREE_TIER_ID } from '../../consts'
import type { FormValues } from '../types'

export const getTierIds = (type: FormValues['type'], formTiers?: Record<string, boolean>) => {
  return reduce(
    formTiers,
    (sum, enabled, id) => {
      if (parseInt(id) === FREE_TIER_ID && type !== 'Custom') return sum

      if (parseInt(id) === FREE_TIER_ID && enabled) {
        sum.push({
          type: 'free',
        })

        return sum
      }

      if (enabled) {
        sum.push({
          type: 'paid',
          id: parseInt(id),
        })
      }

      return sum
    },
    [] as (
      | {
          type: 'free'
        }
      | {
          type: 'paid'
          id: number
        }
    )[],
  )
}
